import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import type { LeafRadioField } from '@cigna/leaf-web/lib/wc';
import '@cigna/leaf-web/lib/wc/components/radio-field/radio-field';

@Component({
  selector: 'cigna-leaf-radio-field',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-radio-field
      [label]="label"
      [fieldNote]="fieldNote"
      [isError]="isError"
      [isSuccess]="isSuccess"
      [isOptional]="isOptional"
      [optionalText]="optionalText"
      [isValid]="isValid"
      [validationNote]="validationNote"
    >
      <ng-content></ng-content>
    </leaf-radio-field>
  `,
})
export class CignaLeafRadioFieldComponent {
  @Input() fieldNote: LeafRadioField['fieldNote'];
  @Input() isError: LeafRadioField['isError'] = false;
  @Input() isSuccess: LeafRadioField['isSuccess'] = false;
  @Input() isOptional: LeafRadioField['isOptional'] = false;
  @Input() optionalText: LeafRadioField['optionalText'];
  @Input() label: LeafRadioField['label'] = '';
  @Input() isValid: LeafRadioField['isValid'];
  @Input() validationNote: LeafRadioField['validationNote'];
}
